import { IPositioningData } from "../interfaces/IPositioningData";

export const floatingElementStyler = (floatingElement: HTMLElement, _referenceElement: HTMLElement, data: IPositioningData): void => {
    Object.assign(floatingElement.style, {
        left: `${data.x}px`,
        position: "absolute",
        top: `${data.y}px`
    });
};
